(function () {
  'use strict';

  // ---------- answers ----------
  var WHO = {
    partner_her: { label: 'My partner', sub: 'Her', who: 'your partner', him: false },
    partner_him: { label: 'My partner', sub: 'Him', who: 'your partner', him: true },
    mother: { label: 'My mother', who: 'your mother', him: false },
    father: { label: 'My father', who: 'your father', him: true },
    daughter: { label: 'My daughter', who: 'your daughter', him: false },
    son: { label: 'My son', who: 'your son', him: true },
    friend: { label: 'A dear friend', who: 'a dear friend', him: false },
    myself: { label: 'Myself', who: 'yourself', him: false }
  };
  var OCCASION = {
    birthday: { label: 'A birthday', title: 'A birthday gift for {who}' },
    anniversary: { label: 'An anniversary', title: 'An anniversary gift for {who}', words: /\b(love|loves|heart|hearts|letter|letters|forever|kiss|rose|roses|together|infinity)\b/ },
    holidays: { label: 'The holidays', title: 'A holiday gift for {who}' },
    thanks: { label: 'A thank you', title: 'A thank you for {who}', maxPrice: 150 },
    milestone: { label: 'A milestone', sub: 'A new job, a graduation', title: 'For {who}, to mark the moment', words: /\b(spinner|token|key|compass|signet|medal|crown|liberty|skyline|wheel|dharmachakra|lotus)\b/ },
    just: { label: 'Just because', title: 'For {who}, just because', maxPrice: 120 }
  };
  // Style is a ranking signal: it decides which pieces lead, never which pieces exist.
  var STYLE = {
    classic: { label: 'Classic and refined', phrase: 'classic and refined', sets: ['classic'], words: /\b(pearls?|signet|locket|heart|filigree|hyacinth|deco|nouveau|victorian|baroque|classical|oval|teardrop|cameo)\b/, avoid: /\b(skull|skeletons?|punk|bolt|lightning|rope|cloth|leather|bead|beads)\b/ },
    statement: { label: 'A bold statement', phrase: 'bold and confident', minPrice: 280, words: /\b(cuff|statement|bangle|wide|chunky|large|signet|chain bracelet|braided|link)\b/ },
    boho: { label: 'Free spirited', phrase: 'free spirited', sets: ['boho'], words: /\b(rope|cloth|beads?|leather|peace|lotus|turquoise|feather|spinner|harvest|bamboo|fossil|pagoda|dove|butterfl(y|ies)|mermaid|turtle)\b/ },
    rock: { label: 'Downtown edge', phrase: 'with a downtown edge', sets: ['rock'], words: /\b(skull|skeletons?|punk|rock|bolt|lightning|onyx|stealie|steal your face|guitar|rpm|cross|spike|rebel|ear crawler|chain)\b/ },
    minimal: { label: 'Quiet and minimal', phrase: 'quiet and minimal', sets: ['minimal'], maxPrice: 160, words: /\b(stack|studs?|post|mini|petite|small|simple|band|token|bar|dot)\b/, avoid: /\b(statement|chunky|cuff|large|wide)\b/ }
  };
  // Every design collection on the site belongs to a world; the collection question lists them by name.
  var LOVES = {
    gd: { label: 'The Grateful Dead', phrase: 'the Grateful Dead', vendor: 'Grateful Dead', words: /\b(steal your face|dancing bears?|terrapin|lightning bolt|dancing skeletons|grateful dead)\b/,
      extra: ['all-grateful-dead', 'grateful-dead-jewelry-gifts'],
      cols: [['steal-your-face', 'Steal Your Face'], ['dancing-bear-collection', 'Dancing Bear'], ['terrapin', 'Terrapin'], ['13-point-lightning-bolt', '13-Point Lightning Bolt'], ['grateful-dead-dancing-skeletons', 'Dancing Skeletons'], ['harvest-dance-bracelets', 'Harvest Dance'], ['emerald-road-bracelets-limited', 'Emerald Road']] },
    nyc: { label: 'New York City', phrase: 'New York', tags: ['nyc', 'newyork', 'new york', 'skyline', 'subway', 'mta', 'statue of liberty', 'brooklyn', 'empire state building', 'chrysler'],
      cols: [['new-york-skyline-jewelry', 'New York City Skyline'], ['real-new-york-subway-tokens', 'Authentic Subway Tokens']] },
    rock: { label: 'Rock and roll', phrase: 'rock and roll',
      cols: [['rock-n-roll-jewelry', 'Rock and Roll'], ['rebel-punk-collection', 'Rebel Punk'], ['the-star-collection', 'Rock Star'], ['45-rpm', '45 RPM'], ['punk-explosion-collection', 'Punk Explosion']] },
    art: { label: 'Art and museums', phrase: 'art and museums', words: /\b(ennion|ca d'zan|barnes|william morris|wiener werkstatte|belle nouveau|artknots|orient fleur|chand bali)\b/,
      cols: [['the-barnes-foundation-collection', 'The Barnes Foundation'], ['belle-nouveau', 'Belle Nouveau'], ['william-morris', 'William Morris'], ['wiener-werkstatte', 'Wiener Werkstatte'], ['the-jewish-museum', 'The Jewish Museum'], ['the-brooklyn-museum', 'The Brooklyn Museum'], ['the-ringling-museum-of-art', 'The Ringling Museum of Art'], ['the-museum-of-fine-arts-boston', 'Museum of Fine Arts, Boston'], ['the-kennedy-center', 'The Kennedy Center'], ['artknots', 'Art Knots'], ['orient-fleur', 'Orient Fleur'], ['chand-bali', 'Chand Bali'], ['urn-collection', 'The Signature Urn']] },
    meaning: { label: 'Symbols with meaning', phrase: 'symbols with meaning', words: /\b(hope|faith|serenity|ohm|buddha|peace|infinity|star of david|wander|wild hearts|honor|love letters|love one another|all shall be well|forget me knot|mystical pagoda|dharmachakra|borobudur|kamon|elements)\b/,
      cols: [['mystical-pagoda', 'Mystical Pagoda'], ['dharmachakra', 'Dharmachakra'], ['borobudur-lotus', 'Borobudur Lotus'], ['ceremonial-kamon', 'Ceremonial Kamon'], ['love-letters', 'Love Letters'], ['imagine-peace', 'Imagine Peace'], ['revolution-dove', 'Revolution Dove'], ['self-reflection-collection', 'Self Reflection'], ['elements', 'Elements'], ['wanderlust-collection', 'Wanderlust'], ['kanji-birthstone-charms', 'Hanzi Birthstone'], ['boho-peace-bracelets', 'Boho Peace'], ['scarlet-peace-bracelets', 'Scarlet Peace']] },
    nature: { label: 'Nature and the sea', phrase: 'nature and the sea', words: /\b(sea|turtle|mermaid|crab|starfish|shells?|sand dollar|oyster|sailboat|anchor|butterfl(y|ies)|dragonfly|flower|lily|garden|bamboo|feather|snow|cloud|moon|reflection|nusantara|komodo|flores)\b/,
      cols: [['fossil-bambu-bamboo-agate-jewelry', 'Fossil Bamboo'], ['seas-the-day-summer-charm-special', 'Seas the Day']] },
    passions: { label: 'Their little passions', sub: 'Ballet, music, a good cocktail', phrase: 'their little passions',
      cols: [['lifestyle-charms-necklaces', 'Lifestyle Charms']] },
    birthstone: { label: 'Their birthstone', phrase: 'their birthstone', stones: true,
      cols: [['mod-pod-birthstone-collection', 'Mod Pod Birthstone'], ['mod-pod-beads', 'Flashback Finds Beads'], ['holiday-birthstone', 'Holiday Birthstone'], ['real-new-york-subway-tokens', 'Authentic Subway Tokens'], ['ceremonial-kamon', 'Ceremonial Kamon']] },
    any: { label: 'A little of everything', phrase: '' }
  };
  var COL = { any: { label: 'Any collection' } };
  Object.keys(LOVES).forEach(function (w) { (LOVES[w].cols || []).forEach(function (c) { if (!COL[c[0]]) COL[c[0]] = { label: c[1] }; }); });
  var PIECE = {
    bracelet: { label: 'A bracelet', short: 'Bracelets', one: 'bracelet', types: ['BRACELETS', 'BANGLES', 'CUFFS'], tags: ['bracelets', 'bracelet', 'bangles', 'cuffs', 'cuff'] },
    necklace: { label: 'A necklace', short: 'Necklaces', one: 'necklace', types: ['NECKLACES'], tags: ['necklaces', 'necklace', 'pendants'] },
    earrings: { label: 'Earrings', short: 'Earrings', one: 'earrings', types: ['EARRINGS'], tags: ['earrings', 'drop earrings', 'hoop earrings', 'button earrings'] },
    ring: { label: 'A ring', short: 'Rings', one: 'ring', types: ['RINGS'], tags: ['rings', 'ring', 'spin rings', 'stack rings'] },
    spinner: { label: 'A spinner ring', sub: 'It turns on the finger', short: 'Spinner rings', one: 'spinner ring', spinner: true },
    charm: { label: 'A charm', short: 'Charms', one: 'charm', types: ['CHARMS', 'Charms & Pendants'], tags: ['charms'] },
    cufflinks: { label: 'Cufflinks', short: 'Cufflinks', one: 'cufflinks', types: ['CUFFLINKS'], tags: ['cufflinks'] },
    any: { label: 'Open to anything', short: 'Any piece' }
  };
  // The house birthstone chart, as cut on the Kamon, Mod Pod and Subway Token pieces.
  var MONTHS = [
    ['january', 'January', 'Garnet', /\bgarnets?\b/],
    ['february', 'February', 'Amethyst', /\bamethysts?\b/],
    ['march', 'March', 'Blue topaz', /\bblue topaz\b/],
    ['april', 'April', 'White topaz', /\bwhite topaz\b/],
    ['may', 'May', 'Green quartz', /\bgreen quartz\b/],
    ['june', 'June', 'Pearl', /\b(white )?pearls?\b/],
    ['july', 'July', 'Carnelian', /\bcarnelian\b/],
    ['august', 'August', 'Peridot', /\bperidot\b/],
    ['september', 'September', 'Iolite', /\b[il]olite\b/],
    ['october', 'October', 'Pink tourmaline', /\bpink tourmaline\b/],
    ['november', 'November', 'Citrine', /\bcitrine\b/],
    ['december', 'December', 'Turquoise', /\bturquoise\b/]
  ];
  var MONTH = {}; MONTHS.forEach(function (m) { MONTH[m[0]] = { label: m[1], stone: m[2], re: m[3] }; });
  MONTH.none = { label: 'Not sure', stone: '' };
  var BUDGET = {
    u100: { label: 'Under $100', range: [0, 99.99] },
    b100: { label: '$100 to $200', range: [100, 199.99] },
    b200: { label: '$200 to $400', range: [200, 399.99] },
    o400: { label: '$400 and up', range: [400, Infinity] },
    any: { label: 'No set budget', range: [0, Infinity] }
  };
  var SETS_BY_KEY = { who: WHO, occasion: OCCASION, style: STYLE, loves: LOVES, col: COL, piece: PIECE, month: MONTH, budget: BUDGET };

  var EXCLUDED_TYPES = ['Gift Card', 'Service', 'Belt Buckles'];
  var EXCLUDED_TAGS = ['repair', 'service', 'default-hide'];
  var EXCLUDED_HANDLES = ['gift'];

  function lower(a) { return (a || []).map(function (t) { return String(t).toLowerCase(); }); }
  function firstSentence(t) {
    var clean = String(t || '').replace(/\s*[—–]\s*/g, ', ');
    var m = clean.match(/^(.{40,220}?[.!?])(\s|$)/);
    return m ? m[1] : clean.slice(0, 180);
  }
  function stoneText(s) {
    // "mother of pearl", coloured pearls and rope colours are not birthstones
    return s.replace(/mother[\s-]+of[\s-]+pearl/g, ' ').replace(/\b(green|brown|black|grey|gray|pink) pearls?\b/g, ' ').replace(/\bemerald road\b/g, ' ');
  }

  // ---------- engine: pure, testable in Node ----------
  function makeEngine(RANK, SETS) {
    var sets = {}, P = (SETS && SETS.p) || [], S = (SETS && SETS.s) || SETS || {};
    Object.keys(S).forEach(function (k) { if (k === 'p') return; var s = {}; (S[k] || []).forEach(function (h) { s[typeof h === 'number' ? P[h] : h] = true; }); sets[k] = s; });
    function inSet(name, h) { return !!(sets[name] && sets[name][h]); }

    function normalise(p) {
      if (!p || EXCLUDED_HANDLES.indexOf(p.handle) !== -1 || EXCLUDED_TYPES.indexOf(p.product_type) !== -1) return null;
      var tags = lower(p.tags);
      for (var i = 0; i < EXCLUDED_TAGS.length; i++) if (tags.indexOf(EXCLUDED_TAGS[i]) !== -1) return null;
      var variants = (p.variants || []).filter(function (v) { return v.available && parseFloat(v.price) > 0; });
      if (!variants.length || !p.images || !p.images.length) return null;
      var prices = variants.map(function (v) { return parseFloat(v.price); });
      var worn = null;
      for (var k = 1; k < p.images.length && !worn; k++) {
        var im = p.images[k], fn = (im.src.split('/').pop() || '').toUpperCase();
        if (/POUCH|CHART|SIZE|BOX|PACKAG/.test(fn)) continue;
        if (fn.indexOf('DSC') === 0 || fn.indexOf('IMG_') === 0 || /SOHO|LIFESTYLE|MODEL|WORN/.test(fn)) worn = im.src;
      }
      var text = String(p.body_html || '').replace(/<[^>]+>/g, ' ').replace(/&[a-z#0-9]+;/gi, ' ').replace(/\s+/g, ' ').trim();
      var title = String(p.title || '').toLowerCase();
      var hay = (title + ' ' + p.handle.replace(/-/g, ' ') + ' ' + tags.join(' ') + ' ' + variants.map(function (v) { return v.title; }).join(' ')).toLowerCase();
      // birthstones: from the title, or from each variant (multi-stone pieces link straight to the stone)
      var stones = {}, base = stoneText(title + ' ' + p.handle.replace(/-/g, ' '));
      MONTHS.forEach(function (m) {
        if (m[3].test(base)) { stones[m[0]] = 0; return; }
        for (var j = 0; j < variants.length; j++) {
          var vt = stoneText(String(variants[j].title || '').toLowerCase());
          if (m[3].test(vt) || new RegExp('\\b' + m[1].toLowerCase() + '\\b').test(vt)) { stones[m[0]] = variants[j].id; return; }
        }
      });
      var men = tags.indexOf('men') !== -1 || p.product_type === 'CUFFLINKS' || inSet('him', p.handle);
      return {
        handle: p.handle, title: p.title, type: p.product_type || '', vendor: p.vendor || '', tags: tags,
        min: Math.min.apply(null, prices), max: Math.max.apply(null, prices),
        pack: p.images[0].src, worn: worn, line: firstSentence(text), hay: hay, stones: stones,
        men: men, women: tags.indexOf('women') !== -1,
        rank: (RANK && RANK[p.handle]) || 0,
        family: p.title.toLowerCase().split(/ sterling| silver| -|,| \(| and /)[0].split(' ').slice(0, 3).join(' ')
      };
    }

    // ---------- hard filters ----------
    function isFor(p, who) { var w = WHO[who]; if (!w) return true; return w.him ? p.men : p.type !== 'CUFFLINKS'; }
    function isPiece(p, key) {
      var r = PIECE[key];
      if (!r || key === 'any') return true;
      if (r.spinner) return inSet('c:spinner-rings', p.handle) || /\bspin(ner)? rings?\b/.test(p.hay);
      if (r.types.indexOf(p.type) !== -1) return true;
      if (!p.type) for (var i = 0; i < r.tags.length; i++) if (p.tags.indexOf(r.tags[i]) !== -1) return true;
      return false;
    }
    function isLoved(p, key) {
      var r = LOVES[key];
      if (!r || key === 'any') return true;
      if (r.vendor && p.vendor === r.vendor) return true;
      var i, c = (r.cols || []).map(function (x) { return x[0]; }).concat(r.extra || []);
      for (i = 0; i < c.length; i++) if (inSet('c:' + c[i], p.handle)) return true;
      if (r.tags) for (i = 0; i < r.tags.length; i++) if (p.tags.indexOf(r.tags[i]) !== -1) return true;
      if (r.words && r.words.test(p.title.toLowerCase())) return true;
      if (r.stones && Object.keys(p.stones).length) return true;
      return false;
    }
    function isCol(p, key) { return !key || key === 'any' || inSet('c:' + key, p.handle); }
    function inBudget(p, key) { var b = (BUDGET[key] || BUDGET.any).range; return p.min >= b[0] && p.min <= b[1]; }
    function hasStone(p, month) { return !month || month === 'none' || p.stones.hasOwnProperty(month); }

    // which answers act as filters, in question order
    var FILTERS = ['who', 'loves', 'col', 'piece', 'month', 'budget'];
    function passes(p, a, skip) {
      return (skip === 'who' || isFor(p, a.who)) &&
        (skip === 'loves' || isLoved(p, a.loves)) &&
        (skip === 'col' || isCol(p, a.col)) &&
        (skip === 'piece' || isPiece(p, a.piece)) &&
        (skip === 'month' || hasStone(p, a.month)) &&
        (skip === 'budget' || inBudget(p, a.budget));
    }
    // how many pieces each answer to `key` would leave, given the other answers
    function counts(catalogue, a, key, opts) {
      opts = opts || {};
      var probe = {}; FILTERS.forEach(function (k) { probe[k] = a[k]; });
      // later questions are not answered yet when counting an earlier one
      if (opts.upTo) { var stop = FILTERS.indexOf(opts.upTo); FILTERS.forEach(function (k, i) { if (i > stop) probe[k] = undefined; }); }
      if (opts.ignore) opts.ignore.forEach(function (k) { probe[k] = undefined; });
      // budget is counted on the whole edit; the stone is reported alongside, never as a gate
      var stoneWanted = key === 'budget' && probe.month && probe.month !== 'none' ? probe.month : '';
      if (key === 'budget') probe.month = undefined;
      var base = catalogue.filter(function (p) { return passes(p, probe, key); });
      var set = SETS_BY_KEY[key], out = {};
      Object.keys(set).forEach(function (v) {
        var n = 0, stone = 0;
        for (var i = 0; i < base.length; i++) {
          var p = base[i], ok = key === 'loves' ? isLoved(p, v) : key === 'col' ? isCol(p, v) : key === 'piece' ? isPiece(p, v) : key === 'month' ? hasStone(p, v) : key === 'budget' ? inBudget(p, v) : key === 'who' ? isFor(p, v) : true;
          if (ok) { n++; if (stoneWanted && hasStone(p, stoneWanted)) stone++; }
        }
        out[v] = { n: n, stone: stone };
      });
      return out;
    }

    // ---------- ranking ----------
    function styleMatch(p, key) {
      var r = STYLE[key];
      if (!r) return 0;
      var s = 0;
      if (r.sets) for (var i = 0; i < r.sets.length; i++) if (inSet('style_' + r.sets[i], p.handle)) s += 1;
      if (r.words && r.words.test(p.hay)) s += 1;
      if (r.minPrice && p.min >= r.minPrice) s += 1;
      if (r.maxPrice && p.min > r.maxPrice) s -= 1;
      if (r.avoid && r.avoid.test(p.hay)) s -= 1.5;
      return s;
    }
    function occasionMatch(p, a) {
      var o = OCCASION[a.occasion];
      if (!o) return 0;
      var s = 0;
      if (o.words && o.words.test(p.hay)) s += 1;
      if (o.maxPrice && p.min <= o.maxPrice) s += 0.6;
      if (a.occasion === 'birthday' && Object.keys(p.stones).length) s += 0.8;
      if (a.occasion === 'holidays') s += Math.min(p.rank, 30) / 30;
      return s;
    }
    function score(p, a) {
      return Math.log(1 + p.rank) * 3.5 + styleMatch(p, a.style) * 24 + occasionMatch(p, a) * 8 +
        (p.worn ? 5 : 0) + (!(WHO[a.who] || {}).him && p.women ? 1 : 0) + (a.month && hasStone(p, a.month) && a.month !== 'none' ? 2 : 0);
    }
    function sortBy(list, a) {
      return list.map(function (p) { return { p: p, s: score(p, a) }; })
        .sort(function (x, y) { return y.s - x.s || x.p.title.localeCompare(y.p.title); })
        .map(function (x) { return x.p; });
    }
    function diversify(list) {
      var firsts = [], rest = [], seen = {};
      list.forEach(function (p) { if (seen[p.family]) rest.push(p); else { seen[p.family] = true; firsts.push(p); } });
      return firsts.concat(rest);
    }

    // The edit never leaves the world the visitor chose. Tiers, in order:
    // every answer; then without the stone; then outside the budget; then any piece type.
    function compute(catalogue, a) {
      var stone = a.month && a.month !== 'none' ? a.month : '';
      var tiers = [
        { name: 'exact', skip: [] },
        { name: 'nostone', skip: ['month'] },
        { name: 'budget', skip: ['month', 'budget'] },
        { name: 'world', skip: ['month', 'budget', 'col'] },
        { name: 'piece', skip: ['month', 'budget', 'col', 'piece'] }
      ];
      var out = [], seen = {}, used = {}, core = 0, tierOf = {};
      for (var t = 0; t < tiers.length; t++) {
        var tier = tiers[t];
        if (t === 1 && !stone) continue;
        if (t === 2 && (!a.budget || a.budget === 'any')) continue;
        if (t === 3 && (!a.col || a.col === 'any')) continue;
        if (t === 4 && (!a.piece || a.piece === 'any')) continue;
        if (t >= 2 && out.length >= 7) break;
        var probe = {}; FILTERS.forEach(function (k) { probe[k] = tier.skip.indexOf(k) === -1 ? a[k] : undefined; });
        var list = diversify(sortBy(catalogue.filter(function (p) { return !seen[p.handle] && passes(p, probe); }), a));
        if (list.length) used[tier.name] = list.length;
        list.forEach(function (p) { seen[p.handle] = true; tierOf[p.handle] = tier.name; out.push(p); });
        if (t <= 1) core = out.length;
      }
      // the first pick answers every question and has a real worn photograph; otherwise there is none
      var feature = null;
      for (var i = 0; i < core && !feature; i++) if (out[i].worn) feature = out[i];
      return { list: out, feature: feature, tiers: used, tierOf: tierOf, core: core, stone: stone, stoneCount: stone ? (used.exact || 0) : 0 };
    }

    return { normalise: normalise, counts: counts, compute: compute, hasStone: hasStone, isLoved: isLoved, isCol: isCol, styleMatch: styleMatch };
  }

  if (typeof document === 'undefined') {
    if (typeof module === 'object' && module.exports) module.exports = { makeEngine: makeEngine, COL: COL, WHO: WHO, OCCASION: OCCASION, STYLE: STYLE, LOVES: LOVES, PIECE: PIECE, MONTH: MONTH, MONTHS: MONTHS, BUDGET: BUDGET };
    return;
  }

  // ---------- page ----------
  var root = document.querySelector('[data-cgny-ge]');
  if (!root) return;

  function readJSON(sel) { try { return JSON.parse(root.querySelector(sel).textContent) || {}; } catch (e) { return {}; } }
  var IMG = readJSON('[data-ge-images]');
  var engine = makeEngine(readJSON('[data-ge-rank]'), readJSON('[data-ge-sets]'));

  var QUESTIONS = [
    { key: 'who', title: 'Who is the <em>gift</em> for?', hint: 'Choose the person you are thinking of.' },
    { key: 'occasion', title: 'What is the <em>occasion</em>?', hint: 'Every gift has its moment.' },
    { key: 'style', title: 'How would you describe <em>their style</em>?', hint: 'Go with your first instinct. It decides which pieces lead.' },
    { key: 'loves', title: 'What do they <em>love</em>?', hint: 'The thing that lights them up.', counted: true },
    { key: 'col', title: 'Is there a <em>collection</em> they love?', hint: 'Every collection we have for them in this world.', counted: true, skip: 'any', skipLabel: 'Leave it open' },
    { key: 'piece', title: 'What would they <em>wear</em> every day?', hint: 'Only what we have for them is shown.', counted: true, skip: 'any', skipLabel: 'Not sure, keep it open' },
    { key: 'month', title: 'When is their <em>birthday</em>?', hint: 'Only months whose birthstone we set in these pieces are shown.', counted: true, months: true, skip: 'none', skipLabel: 'I don’t know, skip this' },
    { key: 'budget', title: 'What would you <em>like to spend</em>?', hint: 'Shipping is free in the continental United States.', counted: true, skip: 'any', skipLabel: 'No set budget' }
  ];

  // ---------- state ----------
  var state = {};
  var step = 0, history = [];
  var catalogue = null, loading = null;
  var results = [], shown = 0, PAGE = 9, lastRes = null;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var narrow = window.matchMedia('(max-width: 899px)');

  var $ = function (s) { return root.querySelector(s); };
  var cover = $('[data-ge-cover]'), quiz = $('[data-ge-quiz]'), stage = $('[data-ge-stage]');
  var fill = $('[data-ge-bar]'), countEl = $('[data-ge-count]');
  var layers = [$('[data-ge-bg-a]'), $('[data-ge-bg-b]')];
  var resultsWrap = $('[data-ge-results]'), titleEl = $('[data-ge-title]'), ledeEl = $('[data-ge-lede]'), chips = $('[data-ge-chips]');
  var feature = $('[data-ge-feature]'), grid = $('[data-ge-grid]'), more = $('[data-ge-more]'), sheetNote = $('[data-ge-sheet-note]');
  var openPhoto = $('[data-ge-open-photo]'), endPhoto = $('[data-ge-end-photo]'), coverPhoto = $('[data-ge-cover-photo]');
  var NOTES_SRC = root.getAttribute('data-ge-notes-src'), notesLoading = null;
  var veil = $('[data-ge-veil]'), veilText = $('[data-ge-veil-text]'), errorBox = $('[data-ge-error]'), live = $('[data-ge-live]');

  function cdn(src, w) { if (!src) return ''; return (src.indexOf('//') === 0 ? 'https:' + src : src) + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var CURRENCY = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  var LOCALE = document.documentElement.lang || 'en-US';
  function money(n) {
    try { return new Intl.NumberFormat(LOCALE, { style: 'currency', currency: CURRENCY, minimumFractionDigits: n % 1 === 0 ? 0 : 2, maximumFractionDigits: 2 }).format(n); }
    catch (e) { return (CURRENCY === 'USD' ? '$' : CURRENCY + ' ') + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2)); }
  }
  function pieces(n) { return n + (n === 1 ? ' piece' : ' pieces'); }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  // ---------- art-directed photographs: 16:9 on desktop, 9:16 on phones ----------
  // An IMG entry is either a plain catalogue photo (string) or { d, m, x, y }:
  // d = desktop file, m = phone file, x / y = focal point used by object-position on desktop.
  var PLATES = IMG.plates || {};
  function plate(ref) {
    if (!ref) return null;
    if (typeof ref === 'string') return PLATES[ref] || { d: ref, m: ref };
    return ref;
  }
  // a living photograph: a short silent loop, no controls, the poster stands in until it plays
  function videoHTML(p) {
    var pos = (p.x || '50%') + ' ' + (p.y || '50%'), src = narrow.matches ? (p.vm || p.vd) : (p.vd || p.vm);
    var poster = cdn(narrow.matches ? (p.m || p.d) : (p.d || p.m), narrow.matches ? 900 : 1400);
    return '<video class="ge4-vid" muted playsinline loop ' + (reduced ? '' : 'autoplay ') + 'preload="' + (reduced ? 'none' : 'auto') + '" aria-hidden="true" disablepictureinpicture style="object-position:' + pos + '" poster="' + esc(poster) + '" src="' + esc('https:' + src.replace(/^https?:/, '')) + '"></video>';
  }
  function pictureHTML(ref, eager) {
    var p = plate(ref);
    if (!p) return '';
    if (p.vd || p.vm) return videoHTML(p);
    var pos = (p.x || '50%') + ' ' + (p.y || '50%');
    return '<picture><source media="(max-width: 899px)" srcset="' + esc(cdn(p.m || p.d, 750)) + ' 750w, ' + esc(cdn(p.m || p.d, 1200)) + ' 1200w" sizes="100vw">' +
      '<img alt="" ' + (eager ? 'fetchpriority="high" ' : 'loading="lazy" ') + 'decoding="async" style="object-position:' + pos + '" src="' + esc(cdn(p.d, 1800)) + '" srcset="' + esc(cdn(p.d, 1200)) + ' 1200w, ' + esc(cdn(p.d, 1800)) + ' 1800w, ' + esc(cdn(p.d, 2600)) + ' 2600w" sizes="(max-width: 899px) 100vw, 60vw"></picture>';
  }
  if (coverPhoto && !coverPhoto.querySelector('img')) coverPhoto.innerHTML = pictureHTML(IMG.cover, true);
  try { if (sessionStorage.getItem('cgny-ge-arrive')) { sessionStorage.removeItem('cgny-ge-arrive'); root.classList.add('is-arriving'); } } catch (e) {}
  if (endPhoto) endPhoto.innerHTML = pictureHTML(IMG.end, false);

  // scene background: two picture layers that cross-fade once the next one has decoded
  var front = 0, bgCurrent = '';
  function setBg(ref) {
    var p = plate(ref);
    if (!p) return;
    var id = (p.d || '') + '|' + (p.m || '');
    if (id === bgCurrent) return;
    bgCurrent = id;
    var back = layers[1 - front];
    back.innerHTML = pictureHTML(ref, true).replace('sizes="(max-width: 899px) 100vw, 60vw"', 'sizes="(max-width: 899px) 100vw, 56vw"');
    var im = back.querySelector('img'), vid = back.querySelector('video'), done = false;
    var play = function (v) { if (v && !reduced) { v.muted = true; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } };
    var swap = function () {
      if (done || bgCurrent !== id || !back.contains(vid || im)) return;
      done = true;
      var old = layers[1 - layers.indexOf(back)], oldVid = old.querySelector('video');
      back.classList.add('is-on');
      old.classList.remove('is-on');
      front = layers.indexOf(back);
      play(vid);
      // the layer that faded out stops decoding once it is gone
      if (oldVid) setTimeout(function () { if (!old.classList.contains('is-on') && old.contains(oldVid)) oldVid.pause(); }, 1000);
    };
    if (vid) {
      play(vid);
      vid.addEventListener('loadeddata', swap, { once: true });
      setTimeout(swap, 1400);
    } else if (im.decode) im.decode().then(swap, swap); else im.onload = swap;
  }
  function optionImage(key, value) {
    var set = (IMG.q || {})[key] || {};
    if (key === 'col' && !set[value]) return optionImage('loves', state.loves);
    return set[value] || set._ || IMG.cover;
  }
  // the collections of the chosen world, in the house's order
  function worldCols() { return ((LOVES[state.loves] || {}).cols || []).map(function (c) { return c[0]; }); }

  // ---------- catalogue ----------
  function fetchJSON(url) {
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }
  function loadCatalogue() {
    if (catalogue) return Promise.resolve(catalogue);
    if (loading) return loading;
    var all = [];
    function page(n, tries) {
      return fetchJSON('/products.json?limit=250&page=' + n).then(function (d) {
        var list = (d && d.products) || [];
        all = all.concat(list);
        return list.length === 250 && n < 12 ? page(n + 1, 0) : all;
      }, function (e) {
        if (tries < 2) return new Promise(function (r) { setTimeout(r, 900 * (tries + 1)); }).then(function () { return page(n, tries + 1); });
        throw e;
      });
    }
    loading = page(1, 0).then(function (list) { catalogue = list.map(engine.normalise).filter(Boolean); return catalogue; })
      .catch(function (e) { loading = null; throw e; });
    return loading;
  }
  // capsules and reasons come from each product's editorial metafields (assets/cgny-gift-edit-notes.js)
  function loadNotes() {
    if (window.CGNY_GE_NOTES || !NOTES_SRC) return Promise.resolve();
    if (notesLoading) return notesLoading;
    notesLoading = new Promise(function (resolve) {
      var s = document.createElement('script');
      s.src = NOTES_SRC; s.async = true;
      s.onload = s.onerror = function () { resolve(); };
      document.head.appendChild(s);
      setTimeout(resolve, 6000);
    });
    return notesLoading;
  }
  function busy(on, text) {
    if (text) veilText.textContent = text;
    veil.hidden = !on;
    root.setAttribute('aria-busy', on ? 'true' : 'false');
  }
  function withCatalogue(text, fn) {
    if (catalogue) { fn(); return; }
    busy(true, text);
    loadCatalogue().then(function () { busy(false); fn(); }, function () { busy(false); errorBox.hidden = false; });
  }

  // ---------- which answers exist ----------
  function optionCounts(q) {
    if (!q.counted || !catalogue) return null;
    return engine.counts(catalogue, state, q.key, { upTo: q.key });
  }
  function visibleKeys(q, counts) {
    var set = SETS_BY_KEY[q.key];
    return (q.key === 'col' ? worldCols() : Object.keys(set)).filter(function (k) {
      if (q.skip && k === q.skip) return false;
      if (q.key === 'budget' && k === 'any') return false;
      return !counts || counts[k].n > 0;
    });
  }
  // a question with nothing to choose between is answered for the visitor
  function shouldAsk(q) {
    if (!q.counted) return true;
    if (q.key === 'col' && (!state.loves || state.loves === 'any')) return false;
    var c = optionCounts(q), keys = visibleKeys(q, c);
    if (q.months) return keys.length > 0;
    return keys.length > 1;
  }

  // ---------- question rendering ----------
  var ARROW = '<svg class="ge4-opt__a" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h13m-5-5 5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function countLabel(c, q) {
    if (!c) return '';
    var t = pieces(c.n);
    if (q.key === 'budget' && state.month && state.month !== 'none' && c.stone) t += ', ' + c.stone + ' with ' + MONTH[state.month].stone.toLowerCase();
    return t;
  }
  function renderQuestion(i, dir) {
    var q = QUESTIONS[i], set = SETS_BY_KEY[q.key];
    var counts = optionCounts(q), keys = visibleKeys(q, counts);
    var html = '<div class="ge4-q" role="group" aria-labelledby="ge4-q-' + i + '">' +
      '<h2 id="ge4-q-' + i + '" tabindex="-1">' + q.title + '</h2><p>' + esc(q.hint) + '</p>';
    if (q.months) {
      html += '<div class="ge4-months">' + keys.map(function (k, n) {
        var m = set[k];
        return '<button type="button" class="ge4-month' + (state.month === k ? ' is-picked' : '') + '" style="--n:' + n + '" data-ge-pick="' + k + '"><span>' + m.label + '</span><small>' + esc(m.stone) + '</small><i>' + pieces(counts[k].n) + '</i></button>';
      }).join('') + '</div>';
    } else {
      html += '<ol class="ge4-opts">' + keys.map(function (k, n) {
        var o = set[k];
        return '<li><button type="button" class="ge4-opt' + (state[q.key] === k ? ' is-picked' : '') + '" style="--n:' + n + '" data-ge-pick="' + k + '">' +
          '<span class="ge4-opt__n">' + String(n + 1).padStart(2, '0') + '</span><span class="ge4-opt__t">' + esc(o.label) + (o.sub ? '<small>' + esc(o.sub) + '</small>' : '') + '</span>' +
          (counts ? '<span class="ge4-opt__c">' + esc(countLabel(counts[k], q)) + '</span>' : '') + ARROW + '</button></li>';
      }).join('') + '</ol>';
    }
    if (q.skip) {
      var all = counts && counts[q.skip] ? ' <span>' + pieces(counts[q.skip].n) + '</span>' : '';
      html += '<button type="button" class="ge4-skip" data-ge-pick="' + q.skip + '">' + esc(q.skipLabel) + all + '</button>';
    }
    html += '</div>';
    var first = state[q.key] || keys[0];
    var swap = function () {
      stage.innerHTML = html;
      step = i;
      fill.style.setProperty('--p', String((i + 1) / QUESTIONS.length));
      countEl.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(QUESTIONS.length).padStart(2, '0');
      setBg(optionImage(q.key, first));
      var h = stage.querySelector('h2');
      if (h && dir) h.focus({ preventScroll: true });
    };
    var cur = stage.querySelector('.ge4-q');
    if (cur && dir && !reduced) { cur.classList.add('is-out'); setTimeout(swap, 260); } else swap();
  }

  function goTo(i, dir) {
    var q = QUESTIONS[i];
    if (q.counted && !catalogue) { withCatalogue('Gathering the collection', function () { goTo(i, dir); }); return; }
    if (!shouldAsk(q)) {
      state[q.key] = q.skip || 'any';
      if (i < QUESTIONS.length - 1) goTo(i + 1, dir); else showResults();
      return;
    }
    if (dir === 'next' && history[history.length - 1] !== step && cover.hidden && quiz.hidden === false && i !== step) history.push(step);
    renderQuestion(i, dir);
  }

  function begin() {
    state = {}; history = [];
    cover.hidden = true;
    quiz.hidden = false;
    root.setAttribute('data-view', 'quiz');
    step = 0;
    renderQuestion(0, 'next');
    window.scrollTo({ top: 0, behavior: 'auto' });
    loadCatalogue().catch(function () {});
    loadNotes();
  }

  function pick(value, btn) {
    var q = QUESTIONS[step];
    state[q.key] = value;
    // later answers may no longer exist once an earlier one changes
    QUESTIONS.slice(step + 1).forEach(function (n) { delete state[n.key]; });
    if (btn && (btn.classList.contains('ge4-opt') || btn.classList.contains('ge4-month'))) {
      var list = btn.parentElement.closest('.ge4-opts, .ge4-months');
      list.classList.add('has-pick');
      list.querySelectorAll('.is-picked').forEach(function (b) { b.classList.remove('is-picked'); });
      btn.classList.add('is-picked');
      setBg(optionImage(q.key, value));
    }
    setTimeout(function () {
      if (step < QUESTIONS.length - 1) {
        history.push(step);
        var next = step + 1;
        var q2 = QUESTIONS[next];
        if (q2.counted && !catalogue) { withCatalogue('Gathering the collection', function () { advanceFrom(next); }); }
        else advanceFrom(next);
        if (narrow.matches) quiz.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth' });
      } else showResults();
    }, reduced ? 0 : 420);
  }
  function advanceFrom(i) {
    for (; i < QUESTIONS.length; i++) {
      if (shouldAsk(QUESTIONS[i])) { renderQuestion(i, 'next'); return; }
      state[QUESTIONS[i].key] = QUESTIONS[i].skip || 'any';
    }
    showResults();
  }
  function back() {
    if (!history.length) { quiz.hidden = true; cover.hidden = false; root.setAttribute('data-view', 'cover'); return; }
    renderQuestion(history.pop(), 'back');
  }

  // ---------- results ----------
  function headline() {
    var w = WHO[state.who] || WHO.friend;
    var o = OCCASION[state.occasion] || OCCASION.just;
    var t = o.title.replace('{who}', '<em>' + esc(w.who) + '</em>');
    if (state.who === 'myself' && state.occasion === 'thanks') t = 'A thank you to <em>yourself</em>';
    return cap(t) + '.';
  }
  function lede(res) {
    var s = STYLE[state.style], l = LOVES[state.loves], c = state.col && state.col !== 'any' ? COL[state.col] : null;
    var out = s ? cap(s.phrase) : 'Chosen with care';
    if (c) out += ', for a love of ' + c.label;
    else if (l && l.phrase) out += ', for a love of ' + l.phrase;
    out += '.';
    if (res.stone && res.stoneCount) {
      var m = MONTH[res.stone], stone = m.stone.toLowerCase(), featured = res.feature && engine.hasStone(res.feature, res.stone);
      var rest = res.stoneCount - (featured ? 1 : 0);
      if (featured) out += ' Our first pick is set with ' + stone + ', the ' + m.label + ' birthstone' + (rest ? ', and ' + rest + (rest === 1 ? ' more piece follows.' : ' more pieces follow.') : '.');
      else if (res.feature) out += (rest === 1 ? ' The piece set with ' + stone + ', the ' + m.label + ' birthstone, comes right after our first pick.' : ' The ' + rest + ' pieces set with ' + stone + ', the ' + m.label + ' birthstone, come right after our first pick.');
      else out += (rest === 1 ? ' The piece set with ' + stone + ', the ' + m.label + ' birthstone, comes first.' : ' The ' + rest + ' pieces set with ' + stone + ', the ' + m.label + ' birthstone, come first.');
    }
    if (res.tiers.budget) out += ' Pieces just outside your budget follow, marked below.';
    else if (res.tiers.world) out += ' More from the same world follows, marked below.';
    else if (res.tiers.piece) out += ' Other kinds of pieces follow, marked below.';
    return out;
  }
  function chipLabel(k) {
    var o = (SETS_BY_KEY[k] || {})[state[k]];
    if (!o) return k === 'month' ? 'Any month' : k === 'piece' ? 'Any piece' : k === 'budget' ? 'Any budget' : k === 'col' ? 'Any collection' : '';
    if (k === 'who') return o.label + (o.sub ? ' (' + o.sub.toLowerCase() + ')' : '');
    if (k === 'piece') return o.short;
    if (k === 'month') return o.stone ? o.label + ', ' + o.stone.toLowerCase() : 'Any month';
    if (k === 'budget' && state[k] === 'any') return 'Any budget';
    return o.label;
  }
  var CHEV = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2.5 4.5 6 8l3.5-3.5" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHIP_KEYS = ['who', 'occasion', 'style', 'loves', 'col', 'piece', 'month', 'budget'];
  function renderChips() {
    chips.innerHTML = '<span class="ge4-refine__l">Refine</span>' + CHIP_KEYS.filter(function (k) { return k !== 'col' || (state.loves && state.loves !== 'any'); }).map(function (k) {
      return '<div class="ge4-chip-wrap"><button type="button" class="ge4-chip" data-ge-chip="' + k + '" aria-haspopup="true" aria-expanded="false">' + esc(chipLabel(k)) + CHEV + '</button></div>';
    }).join('');
  }
  function closeMenus() {
    chips.querySelectorAll('.ge4-menu').forEach(function (m) { m.remove(); });
    chips.querySelectorAll('[data-ge-chip]').forEach(function (c) { c.setAttribute('aria-expanded', 'false'); });
  }
  function openMenu(chip) {
    var k = chip.getAttribute('data-ge-chip'), was = chip.getAttribute('aria-expanded') === 'true';
    closeMenus();
    if (was) return;
    chip.setAttribute('aria-expanded', 'true');
    var set = SETS_BY_KEY[k];
    var q = QUESTIONS.filter(function (x) { return x.key === k; })[0];
    // counts here use every other current answer, so each line is a real result
    var c = q.counted ? engine.counts(catalogue, state, k) : null;
    var menu = document.createElement('div');
    menu.className = 'ge4-menu'; menu.setAttribute('role', 'menu');
    var keys = k === 'col' ? worldCols().concat('any') : Object.keys(set);
    menu.innerHTML = keys.filter(function (v) { return !c || c[v].n > 0; }).map(function (v) {
      var o = set[v];
      var label = k === 'who' ? o.label + (o.sub ? ' (' + o.sub.toLowerCase() + ')' : '') : k === 'month' ? (o.stone ? o.label + ', ' + o.stone.toLowerCase() : 'Any month') : k === 'piece' ? o.short : (k === 'budget' && v === 'any') ? 'Any budget' : o.label;
      return '<button type="button" role="menuitemradio" aria-checked="' + (state[k] === v || (!state[k] && (v === 'any' || v === 'none'))) + '" data-ge-set="' + k + ':' + v + '"><span>' + esc(label) + '</span>' + (c ? '<small>' + c[v].n + '</small>' : '') + '</button>';
    }).join('');
    chip.parentNode.appendChild(menu);
    var f = menu.querySelector('[aria-checked="true"]') || menu.querySelector('button');
    if (f) f.focus();
  }
  // after a chip change, drop answers that no longer lead anywhere
  function reconcile(changed) {
    if (changed === 'loves') state.col = 'any';
    ['loves', 'col', 'piece', 'month', 'budget'].forEach(function (k) {
      if (k === changed || !state[k] || state[k] === 'any' || state[k] === 'none') return;
      var c = engine.counts(catalogue, state, k);
      if (!c[state[k]] || !c[state[k]].n) state[k] = k === 'month' ? 'none' : 'any';
    });
  }
  var LICENSES = ['Official Grateful Dead', 'Rock & Roll Hall of Fame', 'New-York Historical Society', 'New York Transit Museum', 'The Barnes Foundation', 'Corning Museum of Glass', 'University of Delaware'];
  function fallbackWhy(p) {
    if (p.vendor === 'Grateful Dead') return 'Official Grateful Dead jewelry in sterling silver, a piece any Dead Head will recognize at once.';
    if (engine.isLoved(p, 'nyc')) return 'A small piece of New York to wear every day.';
    if (engine.isLoved(p, 'art')) return 'From a museum collaboration, so it comes with a story to tell.';
    if (engine.isLoved(p, 'rock')) return 'Rock and roll attitude in sterling silver.';
    if (engine.isLoved(p, 'meaning')) return 'A symbol with a meaning, to carry close every day.';
    return p.line;
  }
  // one or two capsules and one sentence: why this piece makes a good gift for them
  // capsules are facts only (birthstone, licence, bestseller, real reviews): one on a card, two on the first pick.
  // the reason is one sentence from the piece's own copy, or the birthstone itself when it was asked for.
  function reasons(p, isFeature) {
    var n = (window.CGNY_GE_NOTES || {})[p.handle] || {}, caps = [];
    var stone = lastRes && lastRes.stone && engine.hasStone(p, lastRes.stone) ? MONTH[lastRes.stone] : null;
    if (stone) caps.push(stone.label + ' birthstone');
    (n.c || []).forEach(function (c) { if (caps.indexOf(c) === -1) caps.push(c); });
    if (p.vendor === 'Grateful Dead' && caps.indexOf('Official Grateful Dead') === -1) caps.push('Official Grateful Dead');
    if (p.rank >= 19) caps.push('Bestseller');
    if (n.s) caps.push(n.s[0].toFixed(1) + ' stars, ' + n.s[1] + ' reviews');
    var why = stone ? 'Set with ' + stone.stone.toLowerCase() + ', their ' + stone.label + ' birthstone.' : (n.w || fallbackWhy(p) || '');
    return { caps: caps.slice(0, isFeature ? 2 : 1), why: why };
  }
  function capsHTML(caps) { return caps.length ? '<span class="ge4-caps">' + caps.map(function (c) { return '<span>' + esc(c) + '</span>'; }).join('') + '</span>' : ''; }
  function priceText(p) { return p.min === p.max ? money(p.min) : 'From ' + money(p.min); }
  function href(p) {
    var v = state.month && p.stones[state.month];
    return '/products/' + encodeURIComponent(p.handle) + (v ? '?variant=' + v : '');
  }
  function openingImage(res) {
    var o = (IMG.open || {});
    var ref = o[state.loves] || o['o_' + state.occasion];
    if (ref) return ref;
    var f = res.feature || res.list[0];
    return f && f.worn ? f.worn : IMG.cover;
  }
  function renderFeature(p, res) {
    if (!p) { feature.hidden = true; feature.innerHTML = ''; return; }
    feature.hidden = false;
    var stone = res.stone && engine.hasStone(p, res.stone) ? MONTH[res.stone] : null, why = reasons(p, true);
    feature.innerHTML =
      '<div class="ge4-feature__photo film"><img alt="' + esc(p.title) + ', worn" loading="lazy" decoding="async" src="' + esc(cdn(p.worn, 1400)) + '" srcset="' + esc(cdn(p.worn, 800)) + ' 800w, ' + esc(cdn(p.worn, 1400)) + ' 1400w" sizes="(max-width: 899px) 100vw, 50vw"></div>' +
      '<div class="ge4-feature__copy"><h3><span>Our first pick' + (stone ? ', set with ' + esc(stone.stone.toLowerCase()) : '') + '</span>' + esc(p.title) + '</h3>' +
      capsHTML(why.caps) +
      (why.why ? '<p class="ge4-feature__why">' + esc(why.why) + '</p>' : '') +
      '<p class="ge4-feature__price">' + priceText(p) + '</p>' +
      '<div class="ge4-feature__row"><a class="ge4-btn" href="' + href(p) + '">See the piece</a></div></div>';
  }
  function typeLabel(p) { return p.type ? p.type.charAt(0) + p.type.slice(1).toLowerCase().replace('charms & pendants', 'charm') : ''; }
  function card(p, n) {
    var why = reasons(p, false);
    return '<a class="ge4-card" style="--d:' + Math.min(n * 70, 560) + 'ms" href="' + href(p) + '">' +
      '<span class="ge4-card__media">' +
        '<span class="ge4-card__pack"><img loading="lazy" decoding="async" alt="' + esc(p.title) + '" src="' + esc(cdn(p.pack, 700)) + '"></span>' +
        (p.worn ? '<span class="film"><img loading="lazy" decoding="async" alt="" src="' + esc(cdn(p.worn, 900)) + '"></span>' : '') +
      '</span>' +
      '<span class="ge4-card__name">' + esc(p.title) + '</span>' + capsHTML(why.caps) +
      (why.why ? '<span class="ge4-card__why">' + esc(why.why) + '</span>' : '') +
      '<span class="ge4-card__meta"><span>' + esc(typeLabel(p)) + '</span><span>' + priceText(p) + '</span></span></a>';
  }
  var DIVIDERS = { budget: 'Just outside your budget', world: 'More from the same world', piece: 'Other kinds of pieces' };
  function interlude(p) {
    var why = reasons(p, false);
    return '<a class="ge4-interlude" href="' + href(p) + '"><span class="ge4-interlude__photo film"><img loading="lazy" decoding="async" alt="' + esc(p.title) + ', worn" src="' + esc(cdn(p.worn, 1600)) + '"></span>' +
      '<span class="ge4-interlude__copy"><span class="ge4-card__name">' + esc(p.title) + '</span>' + capsHTML(why.caps) + (why.why ? '<span class="ge4-card__why">' + esc(why.why) + '</span>' : '') + '<span class="ge4-card__meta"><span>' + esc(typeLabel(p)) + '</span><span>' + priceText(p) + '</span></span></span></a>';
  }
  function renderMore() {
    var batch = results.slice(shown, shown + PAGE), html = '';
    batch.forEach(function (p, n) {
      var i = shown + n, tier = lastRes.tierOf[p.handle], prev = i ? lastRes.tierOf[results[i - 1].handle] : 'exact';
      if (DIVIDERS[tier] && tier !== prev) html += '<p class="ge4-divider"><span>' + DIVIDERS[tier] + '</span></p>';
      html += p === wide ? interlude(p) : card(p, n);
    });
    grid.insertAdjacentHTML('beforeend', html);
    shown += batch.length;
    more.hidden = shown >= results.length;
  }
  var wide = null;
  function showResults() {
    errorBox.hidden = true;
    busy(true, 'Composing your edit');
    Promise.all([loadCatalogue(), loadNotes()]).then(function () {
      var res = lastRes = engine.compute(catalogue, state);
      titleEl.innerHTML = headline();
      ledeEl.textContent = lede(res);
      renderChips();
      grid.innerHTML = '';
      openPhoto.innerHTML = pictureHTML(openingImage(res), true);
      renderFeature(res.feature, res);
      results = res.list.filter(function (p) { return p !== res.feature; });
      // the feature's own shoot is not repeated right below it (moved to the end of its own tier)
      if (res.feature) {
        var prefix = res.feature.worn.split('/').pop().slice(0, 7), order = ['exact', 'nostone', 'budget', 'piece'];
        var shoot = function (p) { return p.worn && p.worn.split('/').pop().slice(0, 7) === prefix ? 1 : 0; };
        results = results.map(function (p, i) { return { p: p, i: i }; }).sort(function (a, b) {
          return order.indexOf(res.tierOf[a.p.handle]) - order.indexOf(res.tierOf[b.p.handle]) || shoot(a.p) - shoot(b.p) || a.i - b.i;
        }).map(function (x) { return x.p; });
      }
      // one worn photograph at full width breaks the sheet, as the Black Friday page alternates scale
      wide = null;
      for (var w = 6; w < Math.min(results.length, PAGE) && !wide; w++) if (results[w].worn && res.tierOf[results[w].handle] === res.tierOf[results[5].handle] && (!res.feature || results[w].worn !== res.feature.worn)) wide = results[w];
      if (wide) { results.splice(results.indexOf(wide), 1); results.splice(6, 0, wide); }
      shown = 0;
      var extra = res.list.length - res.core;
      if (results.length) { renderMore(); sheetNote.textContent = (res.core === 1 ? 'One piece answers every question' : res.core + ' pieces answer every question') + (extra ? ', and ' + extra + ' more come close.' : '.') + ' All available now.'; }
      else { more.hidden = true; sheetNote.textContent = res.feature ? 'One piece fits every answer. Change an answer above to see more.' : ''; if (!res.feature) grid.innerHTML = '<p class="ge4-empty">Nothing matches just yet. Change an answer above, or give a gift card and let them choose.</p>'; }
      quiz.hidden = true; cover.hidden = true; resultsWrap.hidden = false;
      root.setAttribute('data-view', 'results');
      busy(false);
      live.textContent = pieces(res.list.length) + ' in your edit.';
      window.scrollTo({ top: 0, behavior: 'auto' });
    }).catch(function () { busy(false); errorBox.hidden = false; });
  }
  function restart() {
    state = {}; history = [];
    resultsWrap.hidden = true; quiz.hidden = true; cover.hidden = false; errorBox.hidden = true;
    root.setAttribute('data-view', 'cover');
    window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
  }

  // ---------- events ----------
  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-ge-begin]')) { begin(); return; }
    var p = t.closest('[data-ge-pick]');
    if (p && stage.contains(p)) { pick(p.getAttribute('data-ge-pick'), p); return; }
    if (t.closest('[data-ge-back]')) { back(); return; }
    var chip = t.closest('[data-ge-chip]');
    if (chip) { openMenu(chip); return; }
    var set = t.closest('[data-ge-set]');
    if (set) {
      var kv = set.getAttribute('data-ge-set').split(':');
      closeMenus();
      if (state[kv[0]] !== kv[1]) { state[kv[0]] = kv[1]; reconcile(kv[0]); showResults(); }
      return;
    }
    if (!t.closest('.ge4-menu')) closeMenus();
    if (t.closest('[data-ge-restart]')) { restart(); return; }
    if (t.closest('[data-ge-retry]')) { errorBox.hidden = true; if (resultsWrap.hidden && !quiz.hidden) goTo(step); else showResults(); return; }
    if (t.closest('[data-ge-more]')) { renderMore(); return; }
  });
  // considering an answer changes the photograph
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  function preview(e) {
    // touch screens have no hover: the photograph changes on the answer itself, not under a resting finger
    if (e.type === 'mouseover' && !canHover.matches) return;
    var o = e.target.closest && e.target.closest('.ge4-opt, .ge4-month');
    if (!o || !stage.contains(o)) return;
    setBg(optionImage(QUESTIONS[step].key, o.getAttribute('data-ge-pick')));
  }
  stage.addEventListener('mouseover', preview);
  stage.addEventListener('focusin', preview);
  document.addEventListener('click', function (e) { if (!root.contains(e.target)) closeMenus(); });
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeMenus(); return; }
    if (quiz.hidden || e.altKey || e.ctrlKey || e.metaKey) return;
    var n = parseInt(e.key, 10);
    if (n >= 1 && n <= 9) {
      var opts = stage.querySelectorAll('.ge4-opt, .ge4-month');
      if (opts[n - 1]) { e.preventDefault(); opts[n - 1].click(); }
    } else if (e.key === 'ArrowLeft') { e.preventDefault(); back(); }
  });
  // the art direction follows the viewport if it crosses the breakpoint
  var onNarrow = function () { bgCurrent = ''; if (!quiz.hidden) setBg(optionImage(QUESTIONS[step].key, state[QUESTIONS[step].key] || '_')); };
  if (narrow.addEventListener) narrow.addEventListener('change', onNarrow);

  setTimeout(function () { loadCatalogue().catch(function () {}); }, 1200);
})();
